import { render } from "./PaygateView.vue?vue&type=template&id=a5e16dbe&scoped=true"
import script from "./PaygateView.vue?vue&type=script&lang=js"
export * from "./PaygateView.vue?vue&type=script&lang=js"

import "./PaygateView.vue?vue&type=style&index=0&id=a5e16dbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e16dbe"]])

export default __exports__